import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import store from '@/store/index'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'

const Actions = {
  // OU01 よく使う画面設定取得
  getOftenUseListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    return await axios
      // .get(apiMock.OFTEN_USE_LIST)
      .get(api.OFTEN_USE_LIST)
      .then((response) => {
        const path = mutationsTypes.OFTEN_USE_SET_LIST
        commit(path, response.data.data)

        const getData = getters.getOftenUseListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // OU02 よく使う画面設定更新
  editOftenUse: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    return await axios
      // .get(apiMock.OFTEN_USE_EDIT)
      .post(api.OFTEN_USE_EDIT, params)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
